import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const TestimonialList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [list, setList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);

  useEffect(() => {
    callAPI("get",  "admin/testimonials", "");
  }, []);

  const filteredList = list.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.job_role.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle initial data response
  useEffect(() => {
    if (response?.data && statusCode === 200) {
      setList(response.data);
      setIsDelete(false);
    }
  }, [response, statusCode]);

  // Handle delete action
  const deleteRecord = (id) => {
    callAPI("delete", "admin/testimonials" + "/" + id, "");
  };

  useEffect(() => {
    if (statusCode === 204 && !isDelete) {
      toast.success("Testimonial deleted successfully!");
      callAPI("get", "admin/testimonials", ""); // refresh
      setIsDelete(true);
    }
  }, [statusCode, isDelete]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Testimonial List"
            subTitle="Manage all registered Testimonials."
          />
          <Link to='/testimonial/add'>
          <button className="btn">add</button></Link>
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <h5 className="mb-0 fw-semibold">Testimonials</h5>
                </div>
                <div className="col-12 col-md-5"></div>
                <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-start">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by name, job role, or description"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">#</th>
                    <th className="px-4 py-2">Profile Pic</th>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Job Role</th>
                    <th className="px-4 py-2">Company Logo</th>
                    <th className="px-4 py-2">Description</th>
                    <th className="px-4 py-2">Status</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((item, index) => (
                    <tr key={item.id} className="border-bottom">
                      <td className="px-4 py-2">{index + 1}</td>
                      <td className="px-4 py-2">
                        <img
                          src={item.profile_pic}
                          alt="Profile"
                          className="rounded-circle"
                          style={{ width: "40px", height: "40px", objectFit: "cover" }}
                        />
                      </td>
                      <td className="px-4 py-2">{item.name}</td>
                      <td className="px-4 py-2">{item.job_role}</td>
                      <td className="px-4 py-2">
                        <img
                          src={item.company_logo}
                          alt="Company Logo"
                          className="rounded"
                          style={{ width: "40px", height: "40px", objectFit: "contain" }}
                        />
                      </td>
                      <td className="px-4 py-2">{item.description}</td>
                      <td className="px-4 py-2">
                        <span
                          className={`badge ${
                            item.status === "Active" ? "bg-success" : "bg-secondary"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
<div className="d-flex justify-content-center gap-2">
                          <Link
                            to={uiRoutes.admin.testimonial.edit.replace(
                              ":id",
                              item.id
                            )}
                          >
                            <button
                              className="sys-list-table__action edit"
                              title="Edit"
                            >
                              <FaEdit />
                            </button>
                          </Link>
                          <button
                            className="sys-list-table__action delete"
                            title="Delete"
                            onClick={() => deleteRecord(item.id)}
                          >
                            <FaTrash />
                          </button>
                        </div>
                    </tr>
                  ))}
                  {filteredList.length === 0 && (
                    <tr>
                      <td className="text-center py-4" colSpan="8">
                        No testimonials found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TestimonialList;
